import React, { useLayoutEffect } from "react";
import { isMobile, isIOS, isAndroid, isIOS13 } from "react-device-detect";

export default function Mobile() {
  useLayoutEffect(() => {
    if (isMobile) {
      if (isIOS || isIOS13) {
        document.location.href =
          "https://apps.apple.com/sg/app/auto-info-yerevan/id1606609940";
      } else if (isAndroid) {
        document.location.href =
          "https://play.google.com/store/apps/details?id=com.autoinfo&hl=ru&gl=US";
      }
    }
  }, []);
  return <div></div>;
}
